export default function (id, tipo = 'usuario') {
  let window = id ? `usuario.${id}` : 'usuario.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Usuário' + (id ? ` #${id}` : ''),
    width: '500',
    height: '80%',
    minHeight: '500px',
    maxHeight: '500px',
    backdrop: true,
    move: false,
    clickOutside: false,
    windowClass: 'erp-window-modern',
    contentClass: '',
    props: {
      id: id,
      tipo: tipo
    }
  }, () => import('./Usuario.vue'))
    .then((wid) => {
      console.log(wid)
      this.$uloc.window.listen(wid, {
        created: (wid, val) => {
          console.log('Created event')
          this.load()
        }
      })
    }) // return wid
}
